import React from 'react';
import styled from 'styled-components';
import { connect } from 'react-redux';
import moment from 'moment';

import withi18n from '~/utils/withI18n';
import { getDepositRecordList } from '~/actions/actionsSet/recharge';
import { getLabelWithDefaultStr } from '~/utils/i18n';

import FlexBox from '~/components/FlexBox';
import IconWithBG from '~/components/IconWithBG';
import Icon from '~/components/Icon';

type Props = {
  rechargeProcut: Object,
  isLoggedIn: Boolean,
  i18n: Object,
};

const mapStateToProps = ({ rechargeProcut, isLoggedIn }) => ({ rechargeProcut, isLoggedIn });

export default
@withi18n
@connect(mapStateToProps, {})
class Record extends React.Component<Props> {
  _init = false;

  state = { recordList: [], page: 1, end: true };

  componentDidMount() {
    document.querySelector('.body').addEventListener('scroll', this.scroll);
  }

  componentDidUpdate() {
    const productId = this.props.rechargeProcut.productId;
    if (productId && this.props.isLoggedIn && !this._init) {
      this._init = true;
      this.fetchRecordList(1);
    }
  }

  componentWillUnmount() {
    document.querySelector('.body').removeEventListener('scroll', this.scroll);
  }

  translate = (key, defaultVal) =>
    getLabelWithDefaultStr(`exchange-recharge-${key}`, this.props.i18n, defaultVal);

  scroll = () => {
    let _body = document.querySelector('.body');
    if (_body.scrollHeight < _body.offsetHeight + _body.scrollTop + 20 && !this.state.end)
      this.fetchRecordList();
  };

  fetchRecordList = async refresh => {
    if (this.loading) return;
    this.loading = true;
    const page = refresh ? 1 : this.state.page + 1;
    let res = await getDepositRecordList({
      page,
      rows: 20,
      productId: this.props.rechargeProcut.productId,
    });
    if (!res) return;
    let recordList = this.state.recordList;
    recordList.push(...res);
    recordList = refresh ? res : recordList;
    recordList.forEach(item => {
      if (item.txId.length <= 20) return;
      item.shortTxId = `${item.txId.slice(0, 10)}...${item.txId.slice(-10)}`;
    });
    this.setState({ recordList, page, end: res.length < 10 }, () => (this.loading = false));
  };

  refresh = () => {
    if (!this.props.isLoggedIn) return;
    this.fetchRecordList(true);
    this.props.getUserInfo();
  };

  _renderNoData = () => {
    return (
      <NoData>
        <i className="no-icon" />
        <span>{this.translate('noRecords')}</span>
      </NoData>
    );
  };

  render() {
    const { state, props } = this;
    const { rechargeProcut } = props;
    const { name, image } = rechargeProcut;

    return (
      <Wrapper>
        <div className="top">
          <div className="title">{this.translate('history').replace(/{Symbol}/, name)}</div>
          <div className="refresh" onClick={this.refresh}>
            <Icon type="refresh2" />
            <span>{this.translate('refresh')}</span>
          </div>
        </div>

        <div className="line mobile" />
        {state.recordList.map((item, index) => (
          <div className="box mobile" key={`${item.depositTime}`}>
            <div className="item">
              <IconWithBG width={24} src={image} />
              <div className="code">{name}</div>
              <FlexBox flex={1} />
              <div className="value">
                {item.depositTime && moment(item.depositTime).format('YYYY-MM-DD HH:mm:ss')}
              </div>
            </div>
            <div className="item">
              <div className="key">{this.translate('depositedAmount')}</div>
              <div className="name">{`${item.transferAmount} ${name}`}</div>
            </div>
            <div className="item">
              <div className="key">{this.translate('depositTier')}</div>
              <div className="name">{item.airdropPercent}</div>
            </div>
            <div className="item">
              <div className="key">{this.translate('reward')}</div>
              <div className="name">{`${item.airdropAmount || '--'} ${name}`}</div>
            </div>
            {state[`showTxid${index}`] && (
              <div className="item">
                <div className="key">TXID</div>
                <div className="name link" onClick={() => window.open(item.txUrl)}>
                  {item.shortTxId || item.txId}
                </div>
              </div>
            )}

            <More
              className="more"
              showTxid={state[`showTxid${index}`]}
              onClick={() =>
                this.setState({
                  [`showTxid${index}`]: !this.state[`showTxid${index}`],
                })
              }
            >
              {!state[`showTxid${index}`] ? this.translate('more') : this.translate('less')}
              <Icon type="Chevrondown" />
            </More>
          </div>
        ))}
        {!state.recordList.length && <div className="mobile">{this._renderNoData()}</div>}
        {!state.end && (
          <div className="more mobile" onClick={() => this.fetchRecordList()}>
            {this.translate('viewMore')}
            <Icon type="Chevrondown" />
          </div>
        )}

        <div className="table">
          <div className="head">
            <div className="date">{this.translate('date')}</div>
            <div className="amount tac">{this.translate('depositedAmount')}</div>
            <div className="level tac">{this.translate('depositTier')}</div>
            <div className="reward tac">{this.translate('reward')}</div>
            <div className="address tar">TXID</div>
          </div>
          <div className="body">
            {state.recordList.map(item => (
              <div className="row" key={item.depositTime}>
                <div className="date">
                  {item.depositTime && moment(item.depositTime).format('YYYY-MM-DD HH:mm:ss')}
                </div>
                <div className="amount tac">{`${item.transferAmount} ${name}`}</div>
                <div className="level tac">{item.airdropPercent}</div>
                <div className="reward tac">{`${item.airdropAmount || '--'} ${name}`}</div>
                <div
                  className="address tar link"
                  onClick={() => window.open(item.txUrl)}
                  title={item.txId}
                >
                  {item.shortTxId || item.txId}
                </div>
              </div>
            ))}
            {!state.recordList.length && this._renderNoData()}
          </div>
        </div>
      </Wrapper>
    );
  }
}

const More = styled.div.attrs(({ className }) => ({
  className,
}))`
  > i {
    transform: ${({ showTxid }) => (showTxid ? 'rotate(180deg)' : 'none')};
  }
`;

const NoData = styled.div`
  height: 260px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  > .no-icon {
    width: 104px;
    height: 104px;
    background: url(${require('../../../static/images/common/norecord.svg')}) no-repeat center/100%;
  }
  > span {
    display: inline-block;
    font-size: 16px;
    margin-top: 16px;
  }
  @media (min-width: 768px) {
    height: 100%;
  }
`;

const Wrapper = styled.div`
  margin: 0 auto;
  width: 100%;
  .link {
    text-decoration: underline;
    text-overflow: ellipsis;
    overflow: hidden;
    word-break: break-all;
    white-space: nowrap;
    cursor: pointer;
    &:hover {
      color: #f0b90b;
    }
  }
  > .table {
    display: none;
  }
  > .top {
    display: flex;
    justify-content: space-between;
    padding: 0 16px;
    > .title {
      font-weight: 500;
      font-size: 16px;
    }
    > .refresh {
      &:hover {
        color: #f0b90b;
        cursor: pointer;
        > span {
          color: #f0b90b;
        }
      }
      > span {
        font-size: 14px;
        margin-left: 5px;
      }
    }
  }
  > .line {
    border-top: 1px solid #eaecef;
    margin: 16px 0;
  }
  > .box {
    margin: 0 16px;
    padding: 16px 0;
    border-bottom: 1px solid #eaecef;
    > .item {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 8px;
      &:first-child {
        margin-bottom: 11px;
      }
      > .key {
        color: #848e9c;
        font-size: 14px;
      }
      > .value {
        font-size: 14px;
      }
      > .code {
        font-weight: 500;
        font-size: 16px;
        margin-left: 4px;
      }
    }
    > .more {
      color: #848e9c;
      font-size: 12px;
      display: flex;
      align-items: center;
      justify-content: flex-end;
    }
  }
  > .more {
    color: #848e9c;
    font-size: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 25px 0 55px;
  }
  @media (min-width: 768px) {
    .line,
    .mobile {
      display: none;
    }
    > .table {
      display: block;
      padding: 16px 16px 24px;
      > .head {
        background: rgba(234, 236, 239, 0.3);
        border-radius: 3px;
        height: 40px;
        padding: 0 21px 0 25px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        font-size: 14px;
        line-height: 18px;
        color: #848e9c;
      }
      > .body {
        height: 400px;
        overflow-y: auto;
        > .row {
          display: flex;
          justify-content: space-between;
          font-size: 12px;
          padding: 12px 21px 12px 25px;
          border-bottom: 1px solid rgba(234, 236, 239, 0.6);
        }
      }

      .tac {
        text-align: center;
      }
      .tar {
        text-align: right;
      }
      .date {
        width: 140px;
      }
      .amount {
        width: 140px;
      }
      .level {
        width: 140px;
      }
      .reward {
        width: 120px;
      }
      .address {
        width: 240px;
      }
    }
  }
  @media (min-width: 1260px) {
    width: 1260px;
    > .top {
      padding: 0px;
    }
    > .table {
      padding: 16px 0px 24px;
    }
  }
`;
